import React, { Component } from "react";
import { Col, Container, Row } from 'reactstrap';
import { withRouter, } from "react-router-dom";
import Select from 'react-select'
import moment from 'moment'
import Lottie from 'lottie-react-web'
import animationData from "../../../lotties/33623-piggy-bank-loop.json";
import ItemsCarousel from 'react-items-carousel';
import { ResponsiveBar } from '@nivo/bar'
import { ResponsiveLine } from '@nivo/line'
import Modal from 'react-modal'
import InputRange from 'react-input-range';
// import '../../../../node_modules/react-input-range/lib/css/index.css';
import 'react-input-range/lib/css/index.css';


const customStyles = { content : {top: '50%',left: '50%',right: 'auto',bottom: 'auto',marginRight: '-50%',transform: 'translate(-50%, -50%)',width: '70%',height: '70%',} };

class TableroProductos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      valSearch: '',
      findProducts: true,
      arrListVentaByDay: [],

      arrProductos: [],
      reloaded: false,
    }
  }

  componentDidMount() {
    const data = {  }
    fetch("https://hg.wsoft.com.mx/REST/controllers/controllerWebApp.php?opt=getRealtimeProducts", this.headersPOST({ ...data, }))
    .then(response => response.json())
    .then((response) => {
      this.setState({ arrProductos: response.list, reloaded: true, })
    })

  }

  render() {
    const { arrProductos, reloaded, } = this.state
    const { id_producto, date, arrVentasProducto, } = this.props.mainState
    if(!reloaded)
      return null

    let producto = '';
    arrProductos.map((t) => { if(t.id_producto == id_producto ) { producto = t.nombre } })

    return (
      <div className="directorPage__wrapper"  style={{ marginTop: 0, overflow: 'scroll', }}>
        
        <hr />
        <input type={"date"}
          value={date}
          onChange={(event) => {
            this.props.mainsetState({ date: event.target.value, });
          }}
          style={{background: '#f3f3f3', border: '3px solid #F3F3F4', margin: 0, width: '100%', }}
        />
        <div style={{ textAlign: 'center' }}>
          <p className={'ws__list_meta_productos'}>Productos</p>
          <select className={'ws__list_meta_select'} onChange={ (e) => { this.props.mainsetState({ id_producto: e.target.value }, this.props.getInfoByProduct) }}>
            { arrProductos.map((t) => (
              <option value={t.id_producto}>{t.nombre}</option>
            )) }
          </select>
        </div>

        {
          arrVentasProducto.map((t,e) => {
            const porc = parseFloat(t.list.venta[0].kg_actual * 100) / t.list.venta[0].kg
            return (
              <div className={'ws__list_meta_parent'}>
                <p>{t.nombre}</p>
                <Row>
                  <Col>
                    <p className={'ws__list_meta_kg'} style={{ textAlign: 'left', }}>{ t.list.venta[0].kg_actual }</p>
                    <p className={'ws__list_meta_year'} style={{ textAlign: 'left', }}>2021</p>
                  </Col>
                  <Col>
                    <p className={'ws__list_meta_kg'} style={{ textAlign: 'right', }}>{ t.list.venta[0].kg }</p>
                    <p className={'ws__list_meta_year'} style={{ textAlign: 'right', }}>2020</p>
                  </Col>
                </Row>
                <div style={{ width: '100%', height: 16, background: '#f3f3f3', borderRadius: 8, }}>
                  <div style={{ width: `${ porc > 100 ? 100 : porc }%`, height: 16, background: '#b71540', borderRadius: 8, }}></div>
                </div>
                <p className={'ws__list_meta_progress'} style={{ left: `${ porc > 100 ? 80 : porc }%` }}>{ this.number_format(porc, 2) }%</p>
              </div>
            )

          })
        }


      </div>
    )
  }

  getInfoByProduct() {
    this.props.getInfoByProduct()
  }


  pad(n, width, z) {
    z = z || '0';
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
  }

  uniqid() {
    var pr = '', en = false, result;this.seed = function (s, w) {s = parseInt(s, 10).toString(16);return w < s.length ? s.slice(s.length - w) : (w > s.length) ? new Array(1 + (w - s.length)).join('0') + s : s;};result = pr + this.seed(parseInt(new Date().getTime() / 1000, 10), 8) + this.seed(Math.floor(Math.random() * 0x75bcd15) + 1, 5);if (en) {result += (Math.random() * 10).toFixed(8).toString();} return result;
  }

  getStyleModal(opt) {
    return { content : {top: '50%',left: '50%',right: 'auto',bottom: 'auto',marginRight: '-50%',transform: 'translate(-50%, -50%)',width: '80%',height: '80%',} };
  }

  number_format(number, decimals, decPoint, thousandsSep) {
    number = (number+'').replace(/[^0-9+\-Ee.]/g, '')
    var n = !isFinite(+number) ? 0 : +number
    var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
    var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
    var dec = (typeof decPoint === 'undefined') ? '.' : decPoint
    var s = ''
    var toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec)
      return ''+(Math.round(n * k) / k)
      .toFixed(prec)
    }
    s = (prec ? toFixedFix(n, prec) : ''+Math.round(n)).split('.')
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
    }
    if ((s[1] || '').length < prec) {
      s[1] = s[1] || ''
      s[1] += new Array(prec - s[1].length+1).join('0')
    }
    return s.join(dec)
  }

  getColorByIndex(e) {
    const color = ['#F0F4FE','#A7CDF2','#E2EFE3','#8FAEE3','#F0F4FE','#A7CDF2','#E2EFE3','#8FAEE3']
    return color[e]
  }


  headersPOST(data) {
    return {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(data),
    }
  }

 getURLByOPT(opt) {
    let PHP = this.props.initState.debug === 1 ? 'controllerPreproduction.php' : 'controllerWebApp.php'
    return `https://hg.wsoft.com.mx/REST/controllers/${PHP}?opt=${opt}`
  }


}

export default withRouter(TableroProductos)